import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

async function parseJson(resp) {
  try {
    return await resp.json();
  } catch {
    return {};
  }
}

/**
 * List unique evaluation + KoT + saved table-replay videos for a training session.
 * @returns {{ clips: Array, counts: { total, evaluation, kot, table_replay }, ts_id: string }}
 */
export async function fetchSessionEvaluationVideos(tsId) {
  const resp = await fetch(`${ip_back}api/mobileAPI/sessionEvaluationVideos`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ ts_id: tsId }),
  });
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Could not load session media files");
  }
  return (
    json.data || {
      clips: [],
      counts: { total: 0, evaluation: 0, kot: 0, table_replay: 0 },
    }
  );
}
